export type HexCode = `#${string}`
export const isHexCode = (str: string): str is HexCode => str.startsWith('#')

export interface KisweSelectOption {
  /** @deprecated: use 'value' instead */
  key?: string|null,
  value?: number|string|null,
  label: string,
  disabled?: boolean
}

export enum KisweModalMode {
  None = 'none',
  Edit = 'edit',
  Create = 'create',
  Read = 'read',
  Preview = 'preview'
}

export interface KisweToggleButtonOption {
  label: string,
  value: string
}

export enum KisweSize {
  Mini = 'mini',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge'
}

export enum KisweTheme {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Quaternary = 'quaternary',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
  None = 'none',
  NoneHover = 'none-hover',
  Neutral = 'neutral'
}

export enum KisweShape {
  Dynamic = 'dynamic',
  Circle = 'circle',
  Square = 'square',
  Rect = 'rect'
}

export enum AspectRatio {
  Auto = 'auto',
  Aspect16x9 = '16/9'
}

export enum TabPushMode {
  Toggle = 'toggle',
  Hold = 'hold'
}

export enum TabViewMode {
  Panel = 'panel',
  State = 'state'
}

interface KisweTabBase {
  id: string,
  notification?: boolean,
  theme?: KisweTheme,
  tooltip?: KisweTooltip,
  type: 'text'|'icon',
  pushMode?: TabPushMode,
  viewMode?: TabViewMode,
  group?: string,
  selected?: boolean,
  disabled?: boolean
}

interface KisweTooltip {
  content: string,
  show?: boolean,
  trigger: 'hover' | 'click' | 'focus' | 'manual',
  classes?: [ string ]
}

interface KisweTabStyle extends KisweTabBase {
  label?: string
  icon?: string,
  type: 'text'
}

interface KisweTabIcon extends KisweTabBase {
  icon: string,
  type: 'icon'
}

export type KisweTab = KisweTabStyle|KisweTabIcon

export interface KisweTabState {
  id: string,
  active: boolean
}

export enum KisweInputType {
  Text = 'text',
  TextArea = 'textarea',
  Number = 'number',
  Email = 'email',
  Password = 'password',
  Color = 'color',
  Duration = 'duration'
}

export enum KisweDisabledDate {
  BeforeNow = 'beforeNow',
  AfterNow = 'afterNow',
  None = 'none'
}

interface StylingBackgroundColor {
  color: HexCode,
  image: null,
  name: null
}

interface StylingBackgroundImage {
  color: null,
  image: string,
  name: string
}

export type StylingBackground = StylingBackgroundColor|StylingBackgroundImage

export enum ActionState {
  Init = 'init',
  InProgress = 'in-progress',
  Success = 'success',
  Error = 'error'
}

export enum KisweSpin {
  Off = 'off',
  Clockwise = 'clockwise',
  AntiClockwise = 'anticlockwise'
}

export interface ItemDragData {
  fromItemId: string,
  toItemId: string|null
}
